/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Lastgrademath2Inputs */



/**

* @param {_Field_Lastgrademath2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_lastgrademath2 = /** @type {((inputs?: _Field_Lastgrademath2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Lastgrademath2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Letzte Note im Fach Mathematik")
});
export { _field_lastgrademath2 as "_field_lastGradeMath" }